//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18nVars from '~/mixins/i18nVars'

export default {
  name: 'BlueDeal',
  mixins: [i18nVars],
  props: {
    lang: {
      type: String,
      default: 'en'
    }
  },
  methods: {
    navigate (url) {
      if (url && url !== 'best-deal-link' && url !== '-') {
        window.location.href = url
      }
    }
  }
}
